/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadExchangeDestination } from './LeadExchangeDestination';
import {
    LeadExchangeDestinationFromJSON,
    LeadExchangeDestinationFromJSONTyped,
    LeadExchangeDestinationToJSON,
    LeadExchangeDestinationToJSONTyped,
} from './LeadExchangeDestination';

/**
 * 
 * @export
 * @interface GetLeadExchangeDestinationsResponseData
 */
export interface GetLeadExchangeDestinationsResponseData {
    /**
     * 
     */
    state: GetLeadExchangeDestinationsResponseDataStateEnum;
    /**
     * 
     */
    facilities: Array<LeadExchangeDestination>;
}


/**
 * @export
 */
export const GetLeadExchangeDestinationsResponseDataStateEnum = {
    Disabled: 'disabled',
    NoDestinations: 'no_destinations',
    Available: 'available',
} as const;
export type GetLeadExchangeDestinationsResponseDataStateEnum = typeof GetLeadExchangeDestinationsResponseDataStateEnum[keyof typeof GetLeadExchangeDestinationsResponseDataStateEnum];


/**
 * Check if a given object implements the GetLeadExchangeDestinationsResponseData interface.
 */
export function instanceOfGetLeadExchangeDestinationsResponseData(value: object): value is GetLeadExchangeDestinationsResponseData {
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('facilities' in value) || value['facilities'] === undefined) return false;
    return true;
}

export function GetLeadExchangeDestinationsResponseDataFromJSON(json: any): GetLeadExchangeDestinationsResponseData {
    return GetLeadExchangeDestinationsResponseDataFromJSONTyped(json, false);
}

export function GetLeadExchangeDestinationsResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadExchangeDestinationsResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'state': json['state'],
        'facilities': ((json['facilities'] as Array<any>).map(LeadExchangeDestinationFromJSON)),
    };
}

export function GetLeadExchangeDestinationsResponseDataToJSON(json: any): GetLeadExchangeDestinationsResponseData {
    return GetLeadExchangeDestinationsResponseDataToJSONTyped(json, false);
}

export function GetLeadExchangeDestinationsResponseDataToJSONTyped(value?: GetLeadExchangeDestinationsResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': value['state'],
        'facilities': ((value['facilities'] as Array<any>).map(LeadExchangeDestinationToJSON)),
    };
}

